<div class="modal fade" bsModal #recoveryModal="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="m0 text-center">Remaining Log Time</h4>
        <p class="text-center m0 mt-sm text-muted">
          Time from your previous session was not logged. Please log (you can adjust it) or discard each entry to continue.
        </p>
      </div>
      <div class="modal-body recovery-body">
        <div class="recovery-item" *ngFor="let item of items; trackBy: trackItem">
          <ul class="reminder-list list-unstyled border-list m0">
            <li class="list">
              <label class="field-label">Patient Name</label>
              <h4 class="m0">{{item.block.patient_name}}
                <small class="text-uppercase" *ngIf="item.block.programme_type"> · {{item.block.programme_type}}</small>
              </h4>
              <small class="text-muted">Worked on {{item.block.captured_at | date:'MMM d, y h:mm a'}} ({{item.block.month}})</small>
            </li>
            <li class="list">
              <label class="field-label">Total Session time</label>
              <h4 class="m0">{{item.block.session_seconds / 60 | number:'1.2-2'}} min</h4>
            </li>
            <li class="list">
              <label class="field-label">Logged time</label>
              <h4 class="m0">{{item.block.logged_seconds / 60 | number:'1.2-2'}} min</h4>
            </li>
            <ng-container *ngIf="!item.block.locked">
              <li class="list">
                <label class="field-label">Remaining unlogged time</label>
                <h4 class="m0">{{item.minutes | number:'1.2-2'}} min</h4>
                <input type="range" name="minutes-{{key(item.block)}}" min="0" [attr.max]="item.block.minutes" step="0.01"
                  [(ngModel)]="item.minutes" [disabled]="item.busy || busyAll"/>
              </li>
              <li class="list">
                <label class="field-label">Description</label>
                <input type="text" class="form-control" name="description-{{key(item.block)}}"
                  [(ngModel)]="item.description" [disabled]="item.busy || busyAll">
              </li>
            </ng-container>
          </ul>
          <div class="alert alert-warning p mt-sm m0" *ngIf="item.block.locked">
            {{item.block.month}} has already been billed, so this {{item.block.minutes | number:'1.2-2'}} min can not be
            logged. You can only discard it.
          </div>
          <div class="alert alert-danger p mt-sm m0" *ngIf="item.error">{{item.error}}</div>
          <div class="text-right mt-sm">
            <ng-container *ngIf="!item.confirmDiscard">
              <button type="button" class="btn btn-tertiary btn-outline mr" [disabled]="item.busy || busyAll"
                (click)="item.confirmDiscard = true">Discard</button>
              <button type="button" class="btn btn-secondary btn-min" *ngIf="!item.block.locked"
                [disabled]="!canLog(item)" (click)="log(item)">Log</button>
            </ng-container>
            <ng-container *ngIf="item.confirmDiscard">
              <span class="mr">Discard {{item.block.locked ? item.block.minutes : item.minutes | number:'1.2-2'}} min permanently?</span>
              <button type="button" class="btn btn-tertiary btn-outline mr" [disabled]="item.busy"
                (click)="item.confirmDiscard = false">Back</button>
              <button type="button" class="btn btn-danger" [disabled]="item.busy" (click)="discard(item)">Yes, discard</button>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="modal-footer" *ngIf="items.length > 1">
        <button type="button" class="btn btn-secondary btn-min" [disabled]="!anyLoggable" (click)="logAll()">Log all</button>
      </div>
    </div>
  </div>
</div>
